import { render, staticRenderFns } from "./GraphRecurringProfit.vue?vue&type=template&id=f06f0d4c&"
import script from "./GraphRecurringProfit.vue?vue&type=script&lang=js&"
export * from "./GraphRecurringProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports